import ProfileView from '../components/profile/ProfileView';

const ProfileSettingsPage: React.FC = () => {
  return <ProfileView />;
};

export default ProfileSettingsPage;
